import { useEffect, useState } from "react";
import { getFileUrls } from "../API/fileUrls";

/**
 * Resolve signed URLs for a set of stored files.
 *
 * Pass every file id a screen is about to show; they are fetched in one
 * batched request. Returns a map of fileId -> { preview, download }, empty
 * until it resolves, so callers should render a fallback meanwhile.
 */
export default function useFileUrls(fileIds) {
  const ids = (Array.isArray(fileIds) ? fileIds : [fileIds]).filter(Boolean).map(String);
  // Stable dependency so the effect does not re-run on every render just
  // because the caller built a new array.
  const key = ids.slice().sort().join(",");

  const [urls, setUrls] = useState({});

  useEffect(() => {
    let cancelled = false;
    if (!key) {
      setUrls({});
      return undefined;
    }
    getFileUrls(key.split(",")).then((resolved) => {
      if (!cancelled) setUrls(resolved);
    });
    return () => {
      cancelled = true;
    };
  }, [key]);

  return urls;
}
